var _rect, _mask, _path, _tspan, _mask2, _path2, _tspan2, _path3, _g, _tspan3, _path4, _g2, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 200,
    viewBox: "0 0 411 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1002_44525)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1002_44525)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 10,
    width: 370,
    height: 160,
    rx: 10,
    className: "component-background"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1002_44525)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1002_44525",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16C20.5 12.6863 23.1863 10 26.5 10H384.5C387.814 10 390.5 12.6863 390.5 16V58H20.5V16Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10H390.5H20.5ZM390.5 59H20.5V57H390.5V59ZM20.5 58V10V58ZM390.5 10V58V10Z",
    className: "component-divider",
    fillOpacity: 0.15,
    mask: "url(#path-3-inside-1_1002_44525)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 30.5,
    y: 42.71
  }, "NOTISER")))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_1002_44525",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 58H390.5V109H20.5V58Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390.5 108H20.5V110H390.5V108Z",
    className: "component-divider",
    fillOpacity: 0.15,
    mask: "url(#path-6-inside-2_1002_44525)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 13,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 30.52,
    y: 87.9395
  }, "Nyheter"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "component-foreground",
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.357 68.0922C347.097 67.9922 348.835 68.0002 350.575 68.0002C350.587 68.0002 359.392 68.0002 359.392 68.0002C361.166 68.0002 362.904 67.9922 364.643 68.0922C366.224 68.1822 367.764 68.3742 369.297 68.8032C372.524 69.7052 375.342 71.5892 377.379 74.2602C379.404 76.9142 380.5 80.1632 380.5 83.4992C380.5 86.8392 379.404 90.0862 377.379 92.7402C375.342 95.4102 372.524 97.2952 369.297 98.1972C367.764 98.6262 366.224 98.8172 364.643 98.9082C362.904 99.0082 361.166 98.9992 359.426 98.9992C359.414 98.9992 350.607 99.0002 350.607 99.0002C348.835 98.9992 347.097 99.0082 345.357 98.9082C343.777 98.8172 342.237 98.6262 340.704 98.1972C337.477 97.2952 334.659 95.4102 332.622 92.7402C330.597 90.0862 329.5 86.8392 329.5 83.5002C329.5 80.1632 330.597 76.9142 332.622 74.2602C334.659 71.5892 337.477 69.7052 340.704 68.8032C342.237 68.3742 343.777 68.1822 345.357 68.0922Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_1002_44525)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "button-background",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345 97C352.456 97 358.5 90.9558 358.5 83.5C358.5 76.0442 352.456 70 345 70C337.544 70 331.5 76.0442 331.5 83.5C331.5 90.9558 337.544 97 345 97Z"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 13,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 30.7944,
    y: 138.939
  }, "Matchh\xE4ndelser"))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "component-foreground",
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.357 119.092C347.097 118.992 348.835 119 350.575 119C350.587 119 359.392 119 359.392 119C361.166 119 362.904 118.992 364.643 119.092C366.224 119.182 367.764 119.374 369.297 119.803C372.524 120.705 375.342 122.589 377.379 125.26C379.404 127.914 380.5 131.163 380.5 134.499C380.5 137.839 379.404 141.086 377.379 143.74C375.342 146.41 372.524 148.295 369.297 149.197C367.764 149.626 366.224 149.817 364.643 149.908C362.904 150.008 361.166 149.999 359.426 149.999C359.414 149.999 350.607 150 350.607 150C348.835 149.999 347.097 150.008 345.357 149.908C343.777 149.817 342.237 149.626 340.704 149.197C337.477 148.295 334.659 146.41 332.622 143.74C330.597 141.086 329.5 137.839 329.5 134.5C329.5 131.163 330.597 127.914 332.622 125.26C334.659 122.589 337.477 120.705 340.704 119.803C342.237 119.374 343.777 119.182 345.357 119.092Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_1002_44525)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "component-foreground-id",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365 148C372.456 148 378.5 141.956 378.5 134.5C378.5 127.044 372.456 121 365 121C357.544 121 351.5 127.044 351.5 134.5C351.5 141.956 357.544 148 365 148Z"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 10.5,
    width: 369,
    height: 159,
    rx: 9.5,
    className: "component-border",
    strokeOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1002_44525",
    x: 0.5,
    y: 0,
    width: 410,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_44525"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1002_44525",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1002_44525",
    x: 10.5,
    y: 5,
    width: 390,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_44525"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1002_44525",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_1002_44525",
    x: 323.5,
    y: 65,
    width: 43,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_44525"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1002_44525",
    result: "effect2_dropShadow_1002_44525"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1002_44525",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_1002_44525",
    x: 343.5,
    y: 116,
    width: 43,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_44525"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1002_44525",
    result: "effect2_dropShadow_1002_44525"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1002_44525",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_44525"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 10,
    width: 370,
    height: 160,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.07093825ddff2b9d5d76aeb240ecd852.svg";
export { ForwardRef as ReactComponent };